/**
 * Created by vxg on 2019/06/10.
 */
import request from './request'
import {signHashData, loginAuth, getCertId, getUserCert, isLogin} from './bjcalib'
const serviceName = 'bjca';
export function genClientSignDigestInfo(bizId, data) {
    return request({
        url: `/${serviceName}/client/genClientSignDigestInfo/${bizId}`,
        method: 'post',
        data
    })
}

export function genClientSignDigest(bizId, signCert, data) {
    data.signCert = signCert;
    return request({
        url: `/${serviceName}/client/signDigest/${bizId}`,
        method: 'post',
        data
    })
}

export function genClientSign(bizId, fileId, signDataJson) {
    return request({
        url: `/${serviceName}/client/clientSign/${bizId}/${fileId}`,
        method: 'post',
        data: signDataJson
    })
}

export function onlineSign(bizId,ruleName,data){
    return request({
        url: `/${serviceName}/server/genSign/${bizId}/${ruleName}`,
        method: 'post'
       // data: data
    })
}

export function onlineClientSign(bizId,ruleName){
    return request({
        url: `/${serviceName}/server/genClientSign/${bizId}/${ruleName}`,
        method: 'post'
       // data: data
    })
}

export function onlineServerSign(bizId,fileId,ruleName,data){
    return request({
        url: `/${serviceName}/server/genServerSign/${bizId}/${fileId}/${ruleName}`,
        method: 'post',
        data: data
    })
}

export async function processSign(bizId, data, that) {
    const certId = await getCertId(that)

    if(!certId){
        return null
    }

    const signCert = await getUserCert(certId,that)

      if(!signCert){
        return null
      }

    //判断登陆是否有效
    let result = await isLogin(certId)
    if (!result) {
        result = await loginAuth(certId, that).catch(msg => console.log(msg))
    }

    if(!result){
        return null
    }
    result = await genClientSignDigestInfo(bizId, data).catch(msg => null)
    if (!result) {
        that.$message.error("生成过程信息失败")
        return null
    }
    if (!result.success) {
        //that.$message.error(result.message)
        return result.message
    }
    result = result.data
    let fileId = result[0].fileId
    for (var i = 0; i < result.length; i++) {
        result[i].fileId = fileId
        let signResult = await genClientSignDigest(bizId, signCert, result[i]).catch(msg => null)
        if (signResult == null) {
            that.$message.error("生成pdf摘要失败")
            return null
        }
        if (!signResult.success) {
            that.$message.error(signResult.message)
            return null
        }
        const digestMessages = JSON.parse(signResult.data)

        const hashData = digestMessages.digestMessages[0].hashData
        const data = await signHashData(certId,hashData).catch(msg=>null)
        if(!data){
            that.$message.error("hash签名失败")
            return null
        }

        digestMessages.digestMessages[0].clientSignData = data.retVal

        const clientSign = await genClientSign(bizId,fileId,digestMessages).catch(msg=>{console.log(msg,33)})

        if(!clientSign){
            that.$message.error("pdf签名失败")
            return null
        }
        if(!clientSign.success){
            that.$message.error(clientSign.message)
            return null
        }
        fileId = JSON.parse(clientSign.data).id
    }
    return fileId
}



// WEBPACK FOOTER //
// ./src/api/bjca/bjca.js